export default "__VITE_ASSET__BgpzSZwQ__"